import { motion } from 'framer-motion';
import { AlertCircle, X } from 'lucide-react';

export default function ErrorAlert({ message, onClose }) {
  if (!message) return null;

  return (
    <motion.div
      className="mb-6 bg-red-100 border border-red-300 rounded-[10px] px-6 py-4 flex items-start gap-4"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <AlertCircle size={24} className="text-red-600 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
      <div className="flex-1">
        <p className="text-red-800 font-semibold font-opensans text-sm">
          {message}
        </p>
      </div>
      <motion.button
        onClick={onClose}
        className="text-red-600 hover:text-red-800 transition flex-shrink-0"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <X size={20} strokeWidth={2} />
      </motion.button>
    </motion.div>
  );
}
